// extracted by mini-css-extract-plugin
module.exports = {"container":"_1j64EyEE-qTxZE3oVoInlJ","icon":"WVz5BBiC6zfXsuF1Egmvx","content":"X3pMEdD_tRyWLzkDpava1"};